import { render, staticRenderFns } from "./ShowPdfButton.vue?vue&type=template&id=0c55c1b0&scoped=true&"
import script from "./ShowPdfButton.vue?vue&type=script&lang=ts&"
export * from "./ShowPdfButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55c1b0",
  null
  
)

export default component.exports